import HeaderContainerGrid from '@/components/headerContainer/Grid';
import { useGrid } from '@Components/Grid/context';

export default function Wrapper({ children }) {
  const { definitions: { entityNamePlural } } = useGrid()

  return <>
    <HeaderContainerGrid title={entityNamePlural}>
      <div className='justify-end items-center gap-4 flex'>
        {children}
      </div>
    </HeaderContainerGrid>
  </>
}
